//require('./../../bootstrap');
require("./../utility/float-input-labels");
require("./../app");

